import _get from 'lodash/get';
import {
  DepartmentFilterInputObject,
  FilterGroupingEnum,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): DepartmentFilterInputObject[] {
  const filters: DepartmentFilterInputObject[] = [];

  const managers = _get(filterValues, FieldNames.Managers, []) as OptionItem[];
  if (managers && managers.length > 0) {
    filters.push({
      managerId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: managers.map((manager) => manager.value) },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
